import React from "react";

import { Button, Icon, Link, Notification } from "@stellar/design-system";

interface Step4AllSetProps {
  completeError: string | undefined;
  isCompleting: boolean;
  onStartDisbursement: () => void;
  onExplore: () => void;
}

export const Step4AllSet: React.FC<Step4AllSetProps> = ({
  completeError,
  isCompleting,
  onStartDisbursement,
  onExplore,
}) => (
  <div className="Onboarding__card Onboarding__card--centered">
    {completeError && (
      <Notification variant="error" title="Error" isFilled>
        {completeError}
      </Notification>
    )}
    <div className="Onboarding__allSet">
      <Icon.CheckCircle className="Onboarding__checkIcon" />
      <p>You&apos;re all set!</p>
      <p>Ready to start sending funds?</p>
    </div>
    <Button
      variant="primary"
      size="lg"
      onClick={onStartDisbursement}
      disabled={isCompleting}
      isLoading={isCompleting}
    >
      Start a disbursement
    </Button>
    <Link
      role="button"
      size="md"
      variant="secondary"
      onClick={isCompleting ? undefined : onExplore}
    >
      Explore the Stellar Disbursement Platform
    </Link>
  </div>
);
